// extracted by mini-css-extract-plugin
export default {"filter":"UJMenu_filter__VLIa-","highlightUJID":"UJMenu_highlightUJID__WZnzB","dropdownMenu":"UJMenu_dropdownMenu__qxKXe"};